import { render } from "./IsSingleton.vue?vue&type=template&id=485e86f1&scoped=true"
import script from "./IsSingleton.vue?vue&type=script&lang=js"
export * from "./IsSingleton.vue?vue&type=script&lang=js"

import "./IsSingleton.vue?vue&type=style&index=0&id=485e86f1&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485e86f1"]])

export default __exports__